export const LOGIN_INITIALIZE = "LOGIN_INITIALIZE";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const SIGNUP_INITIALIZE = "SIGNUP_INITIALIZE";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAIL = "SIGNUP_FAIL";

export const FETCH_LOCATIONS_BY_FACTORS_INITIALIZE =
  "FETCH_LOCATIONS_BY_FACTORS_INITIALIZE";
export const FETCH_LOCATIONS_BY_FACTORS_SUCCESS =
  "FETCH_LOCATIONS_BY_FACTORS_SUCCESS";
export const FETCH_LOCATIONS_BY_FACTORS_FAIL =
  "FETCH_LOCATIONS_BY_FACTORS_FAIL";

export const FETCH_LOCATIONS_BY_NAME_INITIALIZE =
  "FETCH_LOCATIONS_BY_NAME_INITIALIZE";
export const FETCH_LOCATIONS_BY_NAME_SUCCESS =
  "FETCH_LOCATIONS_BY_NAME_SUCCESS";
export const FETCH_LOCATIONS_BY_NAME_FAIL = "FETCH_LOCATIONS_BY_NAME_FAIL";

export const FETCH_TOP_CITIES_INITIALIZE = "FETCH_TOP_CITIES_INITIALIZE";
export const FETCH_TOP_CITIES_SUCCESS = "FETCH_TOP_CITIES_SUCCESS";
export const FETCH_TOP_CITIES_FAIL = "FETCH_TOP_CITIES_FAIL";

export const ADD_LIKED_CITY_INITIALIZE = "ADD_LIKED_CITY_INITIALIZE";
export const ADD_LIKED_CITY_SUCCESS = "ADD_LIKED_CITY_SUCCESS";
export const ADD_LIKED_CITY_FAIL = "ADD_LIKED_CITY_FAIL";

export const ADD_DISLIKED_CITY_INITIALIZE = "ADD_DISLIKED_CITY_INITIALIZE";
export const ADD_DISLIKED_CITY_SUCCESS = "ADD_DISLIKED_CITY_SUCCESS";
export const ADD_DISLIKED_CITY_FAIL = "ADD_DISLIKED_CITY_FAIL";

export const DELETE_LIKED_CITY_INITIALIZE = "DELETE_LIKED_CITY_INITIALIZE";
export const DELETE_LIKED_CITY_SUCCESS = "DELETE_LIKED_CITY_SUCCESS";
export const DELETE_LIKED_CITY_FAIL = "DELETE_LIKED_CITY_FAIL";

export const DELETE_DISLIKED_CITY_INITIALIZE =
  "DELETE_DISLIKED_CITY_INITIALIZE";
export const DELETE_DISLIKED_CITY_SUCCESS = "DELETE_DISLIKED_CITY_SUCCESS";
export const DELETE_DISLIKED_CITY_FAIL = "DELETE_DISLIKED_CITY_FAIL";

export const UPDATE_PROFILE_INITIALIZE = "UPDATE_PROFILE_INITIALIZE";
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS";
export const UPDATE_PROFILE_FAIL = "UPDATE_PROFILE_FAIL";

export const ADD_COMPARED_CITIES_INITIALIZE = "ADD_COMPARED_CITIES_INITIALIZE";
export const ADD_COMPARED_CITIES_SUCCESS = "ADD_COMPARED_CITIES_SUCCESS";
export const ADD_COMPARED_CITIES_FAIL = "ADD_COMPARED_CITIES_FAIL";

export const LOGOUT = "LOGOUT";
